import React from 'react';
import { Card, CardContent, CardHeader, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Box } from '@mui/material';
import { useRedirect } from 'react-admin';

import AddIcon from '@mui/icons-material/Add';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import UploadIcon from '@mui/icons-material/Upload';
import AssessmentIcon from '@mui/icons-material/Assessment';

const iconMap = {
  AddIcon,
  VerifiedUserIcon,
  UploadIcon,
  AssessmentIcon
};

const QuickActions = ({ actions }) => {
  const redirect = useRedirect();

  const handleActionClick = (route) => {
    if (route) {
      redirect(route);
    }
  };

  return (
    <Card>
      <CardHeader
        title="Quick Actions"
        titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
        sx={{ pb: 1 }}
      />
      <CardContent sx={{ pt: 0 }}>
        <List disablePadding>
          {actions.map((action, index) => {
            const IconComponent = iconMap[action.icon];

            return (
              <ListItem key={action.id} disablePadding sx={{ mb: index < actions.length - 1 ? 1 : 0 }}>
                <ListItemButton
                  onClick={() => handleActionClick(action.route)}
                  sx={{
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: 'action.hover'
                    }
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <Box
                      sx={{
                        p: 1,
                        borderRadius: 1.5,
                        backgroundColor: 'primary.main',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {IconComponent && <IconComponent fontSize="small" />}
                    </Box>
                  </ListItemIcon>
                  <ListItemText
                    primary={action.title}
                    secondary={action.description}
                    primaryTypographyProps={{
                      variant: 'subtitle2',
                      fontWeight: 600
                    }}
                    secondaryTypographyProps={{
                      variant: 'caption',
                      color: 'text.secondary'
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
};

export default QuickActions;